(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider_2023"] && !Shopify.designMode) return;
  try {
    
    function arccosTransition({ swiper, extendParams, on }) {
        extendParams({
          debugger: false,
        });

        // on("init", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("init");
        // });
        // on("click", (swiper, e) => {
        //   if (!swiper.params.debugger) return;
        //   console.log("click");
        // });
        // on("tap", (swiper, e) => {
        //   if (!swiper.params.debugger) return;
        //   console.log("tap");
        // });
        // on("doubleTap", (swiper, e) => {
        //   if (!swiper.params.debugger) return;
        //   console.log("doubleTap");
        // });
        // on("sliderMove", (swiper, e) => {
        //   if (!swiper.params.debugger) return;
        //   console.log("sliderMove");
        // });
        // on("slideChange", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log(
        //     "slideChange",
        //     swiper.previousIndex,
        //     "->",
        //     swiper.activeIndex
        //   );
        // });
        // on("slideChangeTransitionStart", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("slideChangeTransitionStart");
        // });
        // on("slideChangeTransitionEnd", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("slideChangeTransitionEnd");
        // });
        // on("transitionStart", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("transitionStart");
        // });
        // on("transitionEnd", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("transitionEnd");
        // });
        // on("fromEdge", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("fromEdge");
        // });
        // on("reachBeginning", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("reachBeginning");
        // });
        // on("reachEnd", () => {
        //   if (!swiper.params.debugger) return;
        //   console.log("reachEnd");
        // });
      }

      const heroSwiper = new Swiper(".heroSwiper", {
        modules: [arccosTransition],
        speed: 200,
        autoplay: {
          delay: 8000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        debugger: true,
      });

  } catch(e) { console.error(e); }
})();
})();
